var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('vs-tabs',{attrs:{"alignment":"fixed","value":0}},[_c('vs-tab',{attrs:{"label":"Active template"}},[_c('s-m-s-template-list',{attrs:{"actions-min-width":200}})],1),_c('vs-tab',{attrs:{"label":"Paper bin"}},[_c('s-m-s-template-list',{attrs:{"trash":"","actions-min-width":150}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }